import { Component, ElementRef, Input } from '@angular/core';
import { SafeResourceUrl, SafeUrl } from '@angular/platform-browser';

export interface LabelContentItem {
  label: string;
  checked: boolean;
  value: string;
}

@Component({
  selector: 'app-label-template',
  standalone: false,
  templateUrl: './label-template.component.html',
})
export class LabelTemplateComponent {
  @Input() uploadedImage: string | SafeResourceUrl | SafeUrl | null = null;
  @Input() base64DefaultLogo: string = '';
  @Input() base64SapLogo: string = '';
  @Input() base64Barcode: string = '';
  @Input() base64Watermark: string = '';
  @Input() contentItems: LabelContentItem[] = [];
  @Input() isInsuranceShow: boolean = true;
  @Input() isPackageShow: boolean = true;
  @Input() isQuantityShow: boolean = true;
  @Input() isPhoneSenderShow: boolean = true;
  @Input() isPhoneReceiverShow: boolean = true;
  @Input() isAddressSenderShow: boolean = true;
  @Input() isNameReceiverShow: boolean = true;
  @Input() isWatermarkShow: boolean = true;
  @Input() selectedLabel: string = 'a4';

  constructor(public el: ElementRef<HTMLElement>) {}

  isChecked(value: string): boolean {
    return this.contentItems.find(i => i.value === value)?.checked ?? false;
  }
}
